import React from 'react'
import PropTypes from 'prop-types'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from 'components/material-symbol/icons/Close'
import Dialog from 'components/dialog'
import { useIsMobile } from 'lib/hooks'
import { useNavigateToChannel } from 'lib/stream-messaging/hooks'
import GroupEventAudienceMessageForm from './group-event-audience-message-form'
import useStyles from './styles'

const GroupEventAudienceMessageDialog = ({ trigger, event }) => {
  const fullScreen = useIsMobile()
  const classes = useStyles()
  const navigateToChannel = useNavigateToChannel()

  return (
    <Dialog
      trigger={trigger}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography className={classes.dialogTitle}>
            <Typography className={classes.title}>New Message</Typography>
            <IconButton
              aria-label="Close"
              className={classes.closeButton}
              onClick={closeDialog}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <GroupEventAudienceMessageForm
            event={event}
            onCancel={closeDialog}
            onSuccess={closeDialog}
            onChannelCreated={navigateToChannel}
          />
        </>
      )}
    </Dialog>
  )
}

GroupEventAudienceMessageDialog.propTypes = {
  trigger: PropTypes.node.isRequired,
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    enrollments: PropTypes.array,
    waitlist: PropTypes.shape({
      entries: PropTypes.array,
    }),
  }),
}

export default GroupEventAudienceMessageDialog
export { GroupEventAudienceMessageForm }
